<script>
/* eslint-disable */
import {UInput, USelect} from 'uloc-vue'
import {ErpInput, ErpSField} from 'uloc-vue-plugin-erp'
import CardWidget from "@/reuse/card/Widget"
import CardColumn from "@/reuse/card/Column"
import CardItem from "@/reuse/card/Card"
import CardItemLink from "@/reuse/card/CardItemLink"
import SoftwareStatus from '@/components/dashboard/components/DashWidgets/SoftwareStatus'
import AcessoStats from "@/components/dashboard/components/DashWidgets/AcessoStats"
import AgendaLeiloes from "@/components/dashboard/components/DashWidgets/AgendaLeiloes"
import CadastroStats from "@/components/dashboard/components/DashWidgets/CadastroStats"
import FinanceiroStats from "@/components/dashboard/components/DashWidgets/Faturamento"
import TarefasStats from "@/components/dashboard/components/DashWidgets/Tarefas"
import {getDashboardData} from "@/domain/estatisticas/services"
import SoftwareLogs from "@/components/dashboard/components/DashWidgets/SoftwareLogs"
import SoftwareAvisos from "@/components/dashboard/components/DashWidgets/SoftwareAvisos"
import Processos from "@/components/dashboard/components/DashWidgets/Processos"
import TasksUsuarioMesAtualStats from "@/components/dashboard/components/DashWidgets/TasksUsuarioMesAtualStats";
import TasksUsuarioStats from "@/components/dashboard/components/DashWidgets/TasksUsuarioStats";
import ProcessosClientesStats from "@/components/dashboard/components/DashWidgets/ProcessosClientesStats";
import ProcessosAdvogadosStats from "@/components/dashboard/components/DashWidgets/ProcessosAdvogadosStats";

export default {
  name: 'Dashboard1',
  provide: function () {
    return {
      dashboard: this
    }
  },
  mixins: [],
  components: {
    ProcessosAdvogadosStats,
    ProcessosClientesStats,
    TasksUsuarioMesAtualStats,
    TasksUsuarioStats,
    SoftwareAvisos,
    SoftwareLogs,
    TarefasStats,
    FinanceiroStats,
    CadastroStats,
    AgendaLeiloes,
    AcessoStats,
    SoftwareStatus,
    Processos,
    CardItemLink, CardItem, CardColumn, CardWidget, ErpInput, ErpSField, UInput, USelect
  },
  data() {
    return {
      loading: false,
      basicData: null
    }
  },
  computed: {},
  mounted() {
    this.loadBasicData()
    this.$interval && clearInterval(this.$interval)
    this.$interval = setInterval(() => {
      this.loadBasicData(false)
    }, 60000) // @TODO: Mudar para 60s no mínimo. 5s só para testes
  },
  beforeDestroy() {
    this.$interval && clearInterval(this.$interval)
  },
  methods: {
    loadBasicData(enableLoading = true) {
      if (enableLoading) this.loading = true
      getDashboardData()
          .then(response => {
            if (enableLoading) this.loading = false
            this.basicData = response.data
          })
          .catch(error => {
            if (error.data.status === 401) {
              setTimeout( () => this.$router.push('/logout'), 500) // TMP
              return
            }
            this.alertApiError(error)
            this.$interval && clearInterval(this.$interval)
            if (enableLoading) this.loading = false
          })
    }
  },
  meta: {
    title: 'Dashboard',
    name: 'Dashboard'
  }
}
</script>

<template>
  <div class="flex col-grow no-wrap dashboard-container">
    <transition name="slide" appear>
      <div class="transition-generic w-full">
        <card-widget>
          <card-column>
            <agenda-leiloes/>
            <tarefas-stats/>
            <processos />
            <software-avisos/>
            <tasks-usuario-stats/>
          </card-column>
          <card-column>
            <acesso-stats/>
            <cadastro-stats/>
            <tasks-usuario-mes-atual-stats/>
          </card-column>
          <card-column>
            <software-status/>
            <financeiro-stats/>
            <software-logs />
            <processos-clientes-stats/>
            <processos-advogados-stats/>
          </card-column>
        </card-widget>
      </div>
    </transition>
  </div>
</template>

<style lang="stylus" src="../assets/default.styl"></style>
